import { useStoreMap } from 'effector-react'
import { supportModel } from '~/widgets/Support'
import { Card, Title } from '~/widgets/Support/ui/styled'
import { ContactMethodEnum } from '~/shared/config/enums'
import { sanitizePhoneNumber } from '~/shared/lib/utils'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { PhoneIcon, TelegramIcon } from '~/shared/ui/icons'
import { Description } from './styled'

type DriverSupportServiceDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function DriverSupportServiceDrawer({
  isShow,
  onClose,
}: DriverSupportServiceDrawerProps) {
  const contacts =
    useStoreMap(supportModel.$contacts, (support) =>
      support?.map((support) => ({
        ...support.getAttributes(),
        id: support.getApiId() as UniqueId,
      })),
    ) || []

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      {!contacts?.length && <>Контакты не доступны</>}
      {contacts.map((contact) => (
        <Card key={contact.id} style={{ justifyContent: 'flex-start' }}>
          {contact.method === ContactMethodEnum.phone && <PhoneIcon />}
          {contact.method === ContactMethodEnum.telegram && <TelegramIcon />}
          <div style={{ marginLeft: '12px' }}>
            {contact.method === ContactMethodEnum.phone && (
              <>
                <Description>{contact.description}</Description>
                <a
                  href={`tel:+${sanitizePhoneNumber(contact.value)}`}
                  style={{ textDecoration: 'none' }}
                >
                  <Title>{contact.value}</Title>
                </a>
              </>
            )}
            {contact.method === ContactMethodEnum.telegram && (
              <a
                target='_blank'
                href={contact.value}
                style={{ textDecoration: 'none' }}
                rel='noreferrer'
              >
                <Description>{contact.description}</Description>
              </a>
            )}
          </div>
        </Card>
      ))}
    </DrawerComponent>
  )
}
